import queryString from 'query-string'
import http from '.'
import { apiCourses } from './apiRouter'

const getCourses = (body) => {
  const params = queryString.stringify(body)
  return http.get(`${apiCourses}?${params}`)
}

const getDetail = (id) => {
  return http.get(`${apiCourses}/${id}`)
}

const deleteCourse = (body) => http.delete(apiCourses, { data: body })

const updateCourse = (params, bodyData) => {
  return http.patch(`${apiCourses}/${params}`, bodyData)
}

const CourseServices = {
  getCourses,
  deleteCourse,
  getDetail,
  updateCourse,
}

export default CourseServices
